import { Injectable } from "@angular/core";
import { AlertController, LoadingController, ToastController, ToastOptions } from "@ionic/angular/standalone";

@Injectable({
  providedIn: "root"
})
export class DisplayService {

  constructor(
    private alertController: AlertController,
    private toastController: ToastController,
    private loadingCtrl: LoadingController
  ) {
  }

  async alert(header: string, subHeader: string = null) {
    const alert = await this.alertController.create({
      header: header,
      subHeader: subHeader,
      buttons: [
        {
          text: "Okay"
        }
      ]
    });
    return alert.present();
  }

  public async showLoading() {
    const loading = await this.loadingCtrl.create({
      message: 'Loading...',
      spinner: 'bubbles',
    });
    loading.present();
  }

  public async hideLoading() {
    await this.loadingCtrl.dismiss();
  }

  async deleteAlert(callback, title = "Confirm", content = "Are you sure?") {
    const alert = await this.alertController.create({
      header: title,
      subHeader: content,
      buttons: [
        {
          text: "Cancel"
        },
        {
          text: "Delete",
          role: "destructive",
          handler: async () => {
            await callback();
          }
        }
      ]
    });
    return alert.present();
  }


  /** Generic confirmation dialog with a custom (non-destructive) confirm label. Resolves true if confirmed. */
  async confirm(title = "Confirm", content = "Are you sure?", confirmText = "Confirm"): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      const alert = await this.alertController.create({
        header: title,
        subHeader: content,
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            handler: () => resolve(false),
          },
          {
            text: confirmText,
            handler: () => resolve(true),
          },
        ],
      });
      await alert.present();
      // Covers backdrop dismiss / hardware back.
      alert.onDidDismiss().then((detail) => {
        if (detail?.role === 'backdrop' || detail?.role === 'cancel') {
          resolve(false);
        }
      });
    });
  }


  async toast(
    opts?: ToastOptions
  ) {
    if (!opts.duration) {
      opts.duration = 1200
    }
    const toast = await this.toastController.create(opts);
    return toast.present();
  }
}
